// extracted by mini-css-extract-plugin
module.exports = {"img":"index-module--img--2syjw","text":"index-module--text--3CL2A","link":"index-module--link--14V9V"};